import { defineComponent, ref } from 'vue';
import { VSnackbar } from 'vuetify/components';
import { PromiseDefer } from '@/services/api';

export default defineComponent({
  name: 'ToastComponent',
  setup() {
    const toastMessage = ref("");
    const toastVisible = ref(false);
    let prom: PromiseDefer<boolean>;

    const show = (msg: string) => {
      if (prom) {
        prom.reject();
      }
      prom = new PromiseDefer();

      toastMessage.value = msg;
      toastVisible.value = true;
      prom.promise.then(() => {
        toastVisible.value = false;
      }).catch(() => {
        console.warn("Toast removed before timeout");
      });
      setTimeout(() => {
        prom.resolve(true);
      }, 3000);
    };

    return {
      toastMessage,
      toastVisible,
      show
    };
  }
});